module.exports = __webpack_public_path__ + "img/racecourse-mauritius-turf-2100.1a25067f.svg";